import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld';
import AgreementComponent from '@/components/AgreementComponent';
import LegalTermsComponent from '@/components/LegalTermsComponent';

Vue.use(Router)

export default new Router({
	mode : 'history',
	base : '/',
  routes: [
    {
      path: '/',
      name: 'AgreementComponent',
      component: AgreementComponent
    },
    {
      path: '/terms',
      name: 'LegalTermsComponent',
      component: LegalTermsComponent
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js